import { assertNever } from '@kofno/piper';
import { Maybe } from 'maybeasy';
import { action, makeObservable, observable } from 'mobx';
import { Link } from '../../../../../../../../Resource/Types';
import { LearningCollectionPublishResource } from './Types';
import { PublishingError, PublishingState, error, publishing, ready, waiting } from './Types';
import { FormTemplate } from '../../../../../../../../Resource/FormTemplates/Types';

class PublishingStore {
  @observable
  state: PublishingState = waiting();

  constructor() {
    makeObservable(this);
  }

  @action
  ready = (
    publishLink: Maybe<Link>,
    publishing: LearningCollectionPublishResource,
    template: FormTemplate,
  ) => {
    switch (this.state.kind) {
      case 'ready':
      case 'error':
        break;
      case 'waiting':
      case 'publishing':
        this.state = ready(publishing, publishLink, template);
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  publishing = () => {
    switch (this.state.kind) {
      case 'ready':
        this.state = publishing(this.state);
        break;
      case 'waiting':
      case 'error':
      case 'publishing':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  error = (err: PublishingError) => {
    switch (this.state.kind) {
      case 'waiting':
        break;
      case 'ready':
      case 'publishing':
        this.state = error(err, this.state);
        break;
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };
}

export default PublishingStore;
